// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/memory/v1/memory.proto" (package "agency.memory.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * RetrieveRequest defines parameters for RAG retrieval.
 *
 * @generated from protobuf message agency.memory.v1.RetrieveRequest
 */
export interface RetrieveRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * query_text is the search query.
     *
     * @generated from protobuf field: string query_text = 3
     */
    queryText: string;
    /**
     * top_k is the number of results to return.
     *
     * @generated from protobuf field: uint32 top_k = 4
     */
    topK: number;
    /**
     * min_relevance_score is the minimum relevance threshold.
     *
     * @generated from protobuf field: float min_relevance_score = 5
     */
    minRelevanceScore: number;
    /**
     * filter_metadata filters chunks by metadata.
     *
     * @generated from protobuf field: map<string, string> filter_metadata = 6
     */
    filterMetadata: {
        [key: string]: string;
    };
    /**
     * corpus_ids restricts search to specific corpora.
     *
     * @generated from protobuf field: repeated string corpus_ids = 7
     */
    corpusIds: string[];
    /**
     * include_embedding returns embedding vectors in results.
     *
     * @generated from protobuf field: bool include_embedding = 8
     */
    includeEmbedding: boolean;
}
/**
 * RetrieveResponse represents a retrieved memory chunk with relevance score.
 *
 * @generated from protobuf message agency.memory.v1.RetrieveResponse
 */
export interface RetrieveResponse {
    /**
     * chunk_id uniquely identifies this chunk.
     *
     * @generated from protobuf field: string chunk_id = 1
     */
    chunkId: string;
    /**
     * content is the chunk text content.
     *
     * @generated from protobuf field: string content = 2
     */
    content: string;
    /**
     * relevance_score is the similarity score (0.0-1.0).
     *
     * @generated from protobuf field: float relevance_score = 3
     */
    relevanceScore: number;
    /**
     * metadata contains chunk metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 4
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * corpus_id is the corpus this chunk belongs to.
     *
     * @generated from protobuf field: string corpus_id = 5
     */
    corpusId: string;
    /**
     * embedding is the chunk's embedding vector (if requested).
     *
     * @generated from protobuf field: repeated float embedding = 6
     */
    embedding: number[];
    /**
     * document_id is the parent document identifier.
     *
     * @generated from protobuf field: string document_id = 7
     */
    documentId: string;
    /**
     * created_at is when the chunk was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8
     */
    createdAt?: Timestamp;
}
/**
 * UpsertRequest adds or updates memory chunks.
 *
 * @generated from protobuf message agency.memory.v1.UpsertRequest
 */
export interface UpsertRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * corpus_id is the target corpus.
     *
     * @generated from protobuf field: string corpus_id = 3
     */
    corpusId: string;
    /**
     * chunks are the memory chunks to upsert.
     *
     * @generated from protobuf field: repeated agency.memory.v1.ChunkUpsert chunks = 4
     */
    chunks: ChunkUpsert[];
}
/**
 * ChunkUpsert defines a chunk to add/update.
 *
 * @generated from protobuf message agency.memory.v1.ChunkUpsert
 */
export interface ChunkUpsert {
    /**
     * chunk_id uniquely identifies this chunk (for updates).
     *
     * @generated from protobuf field: string chunk_id = 1
     */
    chunkId: string;
    /**
     * content is the chunk text content.
     *
     * @generated from protobuf field: string content = 2
     */
    content: string;
    /**
     * metadata contains chunk metadata.
     *
     * @generated from protobuf field: map<string, string> metadata = 3
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * embedding is the chunk's embedding vector.
     *
     * @generated from protobuf field: repeated float embedding = 4
     */
    embedding: number[];
    /**
     * document_id is the parent document identifier.
     *
     * @generated from protobuf field: string document_id = 5
     */
    documentId: string;
}
/**
 * UpsertResponse confirms memory upsert.
 *
 * @generated from protobuf message agency.memory.v1.UpsertResponse
 */
export interface UpsertResponse {
    /**
     * chunk_ids are the IDs of upserted chunks.
     *
     * @generated from protobuf field: repeated string chunk_ids = 1
     */
    chunkIds: string[];
    /**
     * corpus_id is the target corpus.
     *
     * @generated from protobuf field: string corpus_id = 2
     */
    corpusId: string;
    /**
     * upserted_count is the number of chunks upserted.
     *
     * @generated from protobuf field: uint32 upserted_count = 3
     */
    upsertedCount: number;
    /**
     * upserted_at is when the upsert occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp upserted_at = 4
     */
    upsertedAt?: Timestamp;
}
/**
 * SearchRequest searches memory without full query details.
 *
 * @generated from protobuf message agency.memory.v1.SearchRequest
 */
export interface SearchRequest {
    /**
     * query is the retrieval query.
     *
     * @generated from protobuf field: agency.memory.v1.RetrieveRequest query = 1
     */
    query?: RetrieveRequest;
}
/**
 * SearchResponse returns search results.
 *
 * @generated from protobuf message agency.memory.v1.SearchResponse
 */
export interface SearchResponse {
    /**
     * chunks are the retrieved memory chunks.
     *
     * @generated from protobuf field: repeated agency.memory.v1.RetrieveResponse chunks = 1
     */
    chunks: RetrieveResponse[];
    /**
     * total_results is the total matching chunks.
     *
     * @generated from protobuf field: uint32 total_results = 2
     */
    totalResults: number;
    /**
     * search_time_ms is the search duration.
     *
     * @generated from protobuf field: int64 search_time_ms = 3
     */
    searchTimeMs: bigint;
}
/**
 * DeleteRequest deletes memory chunks.
 *
 * @generated from protobuf message agency.memory.v1.DeleteRequest
 */
export interface DeleteRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * corpus_id is the target corpus.
     *
     * @generated from protobuf field: string corpus_id = 3
     */
    corpusId: string;
    /**
     * chunk_ids are the chunks to delete.
     *
     * @generated from protobuf field: repeated string chunk_ids = 4
     */
    chunkIds: string[];
}
/**
 * DeleteResponse confirms deletion.
 *
 * @generated from protobuf message agency.memory.v1.DeleteResponse
 */
export interface DeleteResponse {
    /**
     * deleted_count is the number of chunks deleted.
     *
     * @generated from protobuf field: uint32 deleted_count = 1
     */
    deletedCount: number;
    /**
     * deleted_at is when the deletion occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 2
     */
    deletedAt?: Timestamp;
}
/**
 * StoreRequest is an alias for UpsertRequest for interface compatibility.
 *
 * @generated from protobuf message agency.memory.v1.StoreRequest
 */
export interface StoreRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * corpus_id is the target corpus.
     *
     * @generated from protobuf field: string corpus_id = 3
     */
    corpusId: string;
    /**
     * chunks are the memory chunks to store.
     *
     * @generated from protobuf field: repeated agency.memory.v1.ChunkUpsert chunks = 4
     */
    chunks: ChunkUpsert[];
}
/**
 * StoreResponse is an alias for UpsertResponse for interface compatibility.
 *
 * @generated from protobuf message agency.memory.v1.StoreResponse
 */
export interface StoreResponse {
    /**
     * document_ids are the IDs of stored chunks.
     *
     * @generated from protobuf field: repeated string document_ids = 1
     */
    documentIds: string[];
    /**
     * corpus_id is the target corpus.
     *
     * @generated from protobuf field: string corpus_id = 2
     */
    corpusId: string;
    /**
     * stored_count is the number of chunks stored.
     *
     * @generated from protobuf field: uint32 stored_count = 3
     */
    storedCount: number;
    /**
     * stored_at is when the store occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp stored_at = 4
     */
    storedAt?: Timestamp;
}
/**
 * QueryRequest is an alias for RetrieveRequest for interface compatibility.
 *
 * @generated from protobuf message agency.memory.v1.QueryRequest
 */
export interface QueryRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * query_text is the search query.
     *
     * @generated from protobuf field: string query_text = 3
     */
    queryText: string;
    /**
     * top_k is the number of results to return.
     *
     * @generated from protobuf field: uint32 top_k = 4
     */
    topK: number;
    /**
     * min_relevance_score is the minimum relevance threshold.
     *
     * @generated from protobuf field: float min_relevance_score = 5
     */
    minRelevanceScore: number;
    /**
     * filter_metadata filters chunks by metadata.
     *
     * @generated from protobuf field: map<string, string> filter_metadata = 6
     */
    filterMetadata: {
        [key: string]: string;
    };
    /**
     * corpus_ids restricts search to specific corpora.
     *
     * @generated from protobuf field: repeated string corpus_ids = 7
     */
    corpusIds: string[];
}
/**
 * QueryResponse is an alias for SearchResponse for interface compatibility.
 *
 * @generated from protobuf message agency.memory.v1.QueryResponse
 */
export interface QueryResponse {
    /**
     * results are the retrieved memory chunks.
     *
     * @generated from protobuf field: repeated agency.memory.v1.RetrieveResponse results = 1
     */
    results: RetrieveResponse[];
    /**
     * total_results is the total matching chunks.
     *
     * @generated from protobuf field: uint32 total_results = 2
     */
    totalResults: number;
    /**
     * query_time_ms is the query duration.
     *
     * @generated from protobuf field: int64 query_time_ms = 3
     */
    queryTimeMs: bigint;
}
/**
 * UpdateRequest updates chunk metadata without re-embedding.
 *
 * @generated from protobuf message agency.memory.v1.UpdateRequest
 */
export interface UpdateRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * corpus_id is the target corpus.
     *
     * @generated from protobuf field: string corpus_id = 3
     */
    corpusId: string;
    /**
     * chunk_id is the chunk to update.
     *
     * @generated from protobuf field: string chunk_id = 4
     */
    chunkId: string;
    /**
     * metadata is the new metadata (replaces existing).
     *
     * @generated from protobuf field: map<string, string> metadata = 5
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * UpdateResponse confirms metadata update.
 *
 * @generated from protobuf message agency.memory.v1.UpdateResponse
 */
export interface UpdateResponse {
    /**
     * chunk_id is the updated chunk.
     *
     * @generated from protobuf field: string chunk_id = 1
     */
    chunkId: string;
    /**
     * updated_at is when the update occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 2
     */
    updatedAt?: Timestamp;
}
/**
 * GetStatsRequest requests storage statistics.
 *
 * @generated from protobuf message agency.memory.v1.GetStatsRequest
 */
export interface GetStatsRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * corpus_id is the target corpus (empty for all).
     *
     * @generated from protobuf field: string corpus_id = 3
     */
    corpusId: string;
}
/**
 * GetStatsResponse returns storage statistics.
 *
 * @generated from protobuf message agency.memory.v1.GetStatsResponse
 */
export interface GetStatsResponse {
    /**
     * total_chunks is the number of chunks stored.
     *
     * @generated from protobuf field: uint64 total_chunks = 1
     */
    totalChunks: bigint;
    /**
     * total_documents is the number of documents.
     *
     * @generated from protobuf field: uint64 total_documents = 2
     */
    totalDocuments: bigint;
    /**
     * storage_bytes is the total storage used.
     *
     * @generated from protobuf field: uint64 storage_bytes = 3
     */
    storageBytes: bigint;
    /**
     * corpus_id is the corpus these stats are for.
     *
     * @generated from protobuf field: string corpus_id = 4
     */
    corpusId: string;
    /**
     * last_updated is when stats were last computed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_updated = 5
     */
    lastUpdated?: Timestamp;
}
// @generated message type with reflection information, may provide speed optimized methods
class RetrieveRequest$Type extends MessageType<RetrieveRequest> {
    constructor() {
        super("agency.memory.v1.RetrieveRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "query_text", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "8192" } } } },
            { no: 4, name: "top_k", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 100, gte: 1 } } } },
            { no: 5, name: "min_relevance_score", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 6, name: "filter_metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 7, name: "corpus_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 8, name: "include_embedding", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RetrieveRequest>): RetrieveRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.queryText = "";
        message.topK = 0;
        message.minRelevanceScore = 0;
        message.filterMetadata = {};
        message.corpusIds = [];
        message.includeEmbedding = false;
        if (value !== undefined)
            reflectionMergePartial<RetrieveRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RetrieveRequest): RetrieveRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string query_text */ 3:
                    message.queryText = reader.string();
                    break;
                case /* uint32 top_k */ 4:
                    message.topK = reader.uint32();
                    break;
                case /* float min_relevance_score */ 5:
                    message.minRelevanceScore = reader.float();
                    break;
                case /* map<string, string> filter_metadata */ 6:
                    this.binaryReadMap6(message.filterMetadata, reader, options);
                    break;
                case /* repeated string corpus_ids */ 7:
                    message.corpusIds.push(reader.string());
                    break;
                case /* bool include_embedding */ 8:
                    message.includeEmbedding = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: RetrieveRequest["filterMetadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof RetrieveRequest["filterMetadata"] | undefined, val: RetrieveRequest["filterMetadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.memory.v1.RetrieveRequest.filter_metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: RetrieveRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string query_text = 3; */
        if (message.queryText !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.queryText);
        /* uint32 top_k = 4; */
        if (message.topK !== 0)
            writer.tag(4, WireType.Varint).uint32(message.topK);
        /* float min_relevance_score = 5; */
        if (message.minRelevanceScore !== 0)
            writer.tag(5, WireType.Bit32).float(message.minRelevanceScore);
        /* map<string, string> filter_metadata = 6; */
        for (let k of globalThis.Object.keys(message.filterMetadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.filterMetadata[k]).join();
        /* repeated string corpus_ids = 7; */
        for (let i = 0; i < message.corpusIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.corpusIds[i]);
        /* bool include_embedding = 8; */
        if (message.includeEmbedding !== false)
            writer.tag(8, WireType.Varint).bool(message.includeEmbedding);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.RetrieveRequest
 */
export const RetrieveRequest = new RetrieveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RetrieveResponse$Type extends MessageType<RetrieveResponse> {
    constructor() {
        super("agency.memory.v1.RetrieveResponse", [
            { no: 1, name: "chunk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32768" } } } },
            { no: 3, name: "relevance_score", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 4, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 5, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 6, name: "embedding", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { repeated: { maxItems: "4096" } } } },
            { no: 7, name: "document_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RetrieveResponse>): RetrieveResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.chunkId = "";
        message.content = "";
        message.relevanceScore = 0;
        message.metadata = {};
        message.corpusId = "";
        message.embedding = [];
        message.documentId = "";
        if (value !== undefined)
            reflectionMergePartial<RetrieveResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RetrieveResponse): RetrieveResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string chunk_id */ 1:
                    message.chunkId = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                case /* float relevance_score */ 3:
                    message.relevanceScore = reader.float();
                    break;
                case /* map<string, string> metadata */ 4:
                    this.binaryReadMap4(message.metadata, reader, options);
                    break;
                case /* string corpus_id */ 5:
                    message.corpusId = reader.string();
                    break;
                case /* repeated float embedding */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.embedding.push(reader.float());
                    else
                        message.embedding.push(reader.float());
                    break;
                case /* string document_id */ 7:
                    message.documentId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: RetrieveResponse["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof RetrieveResponse["metadata"] | undefined, val: RetrieveResponse["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.memory.v1.RetrieveResponse.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: RetrieveResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string chunk_id = 1; */
        if (message.chunkId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.chunkId);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        /* float relevance_score = 3; */
        if (message.relevanceScore !== 0)
            writer.tag(3, WireType.Bit32).float(message.relevanceScore);
        /* map<string, string> metadata = 4; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* string corpus_id = 5; */
        if (message.corpusId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.corpusId);
        /* repeated float embedding = 6; */
        if (message.embedding.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.embedding.length; i++)
                writer.float(message.embedding[i]);
            writer.join();
        }
        /* string document_id = 7; */
        if (message.documentId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.documentId);
        /* google.protobuf.Timestamp created_at = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.RetrieveResponse
 */
export const RetrieveResponse = new RetrieveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertRequest$Type extends MessageType<UpsertRequest> {
    constructor() {
        super("agency.memory.v1.UpsertRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "chunks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ChunkUpsert, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<UpsertRequest>): UpsertRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.corpusId = "";
        message.chunks = [];
        if (value !== undefined)
            reflectionMergePartial<UpsertRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertRequest): UpsertRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string corpus_id */ 3:
                    message.corpusId = reader.string();
                    break;
                case /* repeated agency.memory.v1.ChunkUpsert chunks */ 4:
                    message.chunks.push(ChunkUpsert.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string corpus_id = 3; */
        if (message.corpusId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.corpusId);
        /* repeated agency.memory.v1.ChunkUpsert chunks = 4; */
        for (let i = 0; i < message.chunks.length; i++)
            ChunkUpsert.internalBinaryWrite(message.chunks[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.UpsertRequest
 */
export const UpsertRequest = new UpsertRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChunkUpsert$Type extends MessageType<ChunkUpsert> {
    constructor() {
        super("agency.memory.v1.ChunkUpsert", [
            { no: 1, name: "chunk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32768" } } } },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 4, name: "embedding", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "4096" } } } },
            { no: 5, name: "document_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ChunkUpsert>): ChunkUpsert {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.chunkId = "";
        message.content = "";
        message.metadata = {};
        message.embedding = [];
        message.documentId = "";
        if (value !== undefined)
            reflectionMergePartial<ChunkUpsert>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChunkUpsert): ChunkUpsert {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string chunk_id */ 1:
                    message.chunkId = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                case /* repeated float embedding */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.embedding.push(reader.float());
                    else
                        message.embedding.push(reader.float());
                    break;
                case /* string document_id */ 5:
                    message.documentId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: ChunkUpsert["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ChunkUpsert["metadata"] | undefined, val: ChunkUpsert["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.memory.v1.ChunkUpsert.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ChunkUpsert, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string chunk_id = 1; */
        if (message.chunkId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.chunkId);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* repeated float embedding = 4; */
        if (message.embedding.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.embedding.length; i++)
                writer.float(message.embedding[i]);
            writer.join();
        }
        /* string document_id = 5; */
        if (message.documentId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.documentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.ChunkUpsert
 */
export const ChunkUpsert = new ChunkUpsert$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertResponse$Type extends MessageType<UpsertResponse> {
    constructor() {
        super("agency.memory.v1.UpsertResponse", [
            { no: 1, name: "chunk_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 2, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "upserted_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "upserted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<UpsertResponse>): UpsertResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.chunkIds = [];
        message.corpusId = "";
        message.upsertedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<UpsertResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertResponse): UpsertResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string chunk_ids */ 1:
                    message.chunkIds.push(reader.string());
                    break;
                case /* string corpus_id */ 2:
                    message.corpusId = reader.string();
                    break;
                case /* uint32 upserted_count */ 3:
                    message.upsertedCount = reader.uint32();
                    break;
                case /* google.protobuf.Timestamp upserted_at */ 4:
                    message.upsertedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.upsertedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string chunk_ids = 1; */
        for (let i = 0; i < message.chunkIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.chunkIds[i]);
        /* string corpus_id = 2; */
        if (message.corpusId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.corpusId);
        /* uint32 upserted_count = 3; */
        if (message.upsertedCount !== 0)
            writer.tag(3, WireType.Varint).uint32(message.upsertedCount);
        /* google.protobuf.Timestamp upserted_at = 4; */
        if (message.upsertedAt)
            Timestamp.internalBinaryWrite(message.upsertedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.UpsertResponse
 */
export const UpsertResponse = new UpsertResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequest$Type extends MessageType<SearchRequest> {
    constructor() {
        super("agency.memory.v1.SearchRequest", [
            { no: 1, name: "query", kind: "message", T: () => RetrieveRequest, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SearchRequest>): SearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequest): SearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.memory.v1.RetrieveRequest query */ 1:
                    message.query = RetrieveRequest.internalBinaryRead(reader, reader.uint32(), options, message.query);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.memory.v1.RetrieveRequest query = 1; */
        if (message.query)
            RetrieveRequest.internalBinaryWrite(message.query, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.SearchRequest
 */
export const SearchRequest = new SearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchResponse$Type extends MessageType<SearchResponse> {
    constructor() {
        super("agency.memory.v1.SearchResponse", [
            { no: 1, name: "chunks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RetrieveResponse, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 2, name: "total_results", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "search_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchResponse>): SearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.chunks = [];
        message.totalResults = 0;
        message.searchTimeMs = 0n;
        if (value !== undefined)
            reflectionMergePartial<SearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchResponse): SearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.memory.v1.RetrieveResponse chunks */ 1:
                    message.chunks.push(RetrieveResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* uint32 total_results */ 2:
                    message.totalResults = reader.uint32();
                    break;
                case /* int64 search_time_ms */ 3:
                    message.searchTimeMs = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.memory.v1.RetrieveResponse chunks = 1; */
        for (let i = 0; i < message.chunks.length; i++)
            RetrieveResponse.internalBinaryWrite(message.chunks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 total_results = 2; */
        if (message.totalResults !== 0)
            writer.tag(2, WireType.Varint).uint32(message.totalResults);
        /* int64 search_time_ms = 3; */
        if (message.searchTimeMs !== 0n)
            writer.tag(3, WireType.Varint).int64(message.searchTimeMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.SearchResponse
 */
export const SearchResponse = new SearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRequest$Type extends MessageType<DeleteRequest> {
    constructor() {
        super("agency.memory.v1.DeleteRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "chunk_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteRequest>): DeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.corpusId = "";
        message.chunkIds = [];
        if (value !== undefined)
            reflectionMergePartial<DeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteRequest): DeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string corpus_id */ 3:
                    message.corpusId = reader.string();
                    break;
                case /* repeated string chunk_ids */ 4:
                    message.chunkIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string corpus_id = 3; */
        if (message.corpusId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.corpusId);
        /* repeated string chunk_ids = 4; */
        for (let i = 0; i < message.chunkIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.chunkIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.DeleteRequest
 */
export const DeleteRequest = new DeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResponse$Type extends MessageType<DeleteResponse> {
    constructor() {
        super("agency.memory.v1.DeleteResponse", [
            { no: 1, name: "deleted_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<DeleteResponse>): DeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.deletedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteResponse): DeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 deleted_count */ 1:
                    message.deletedCount = reader.uint32();
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 2:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 deleted_count = 1; */
        if (message.deletedCount !== 0)
            writer.tag(1, WireType.Varint).uint32(message.deletedCount);
        /* google.protobuf.Timestamp deleted_at = 2; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.DeleteResponse
 */
export const DeleteResponse = new DeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoreRequest$Type extends MessageType<StoreRequest> {
    constructor() {
        super("agency.memory.v1.StoreRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "chunks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ChunkUpsert, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<StoreRequest>): StoreRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.corpusId = "";
        message.chunks = [];
        if (value !== undefined)
            reflectionMergePartial<StoreRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StoreRequest): StoreRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string corpus_id */ 3:
                    message.corpusId = reader.string();
                    break;
                case /* repeated agency.memory.v1.ChunkUpsert chunks */ 4:
                    message.chunks.push(ChunkUpsert.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StoreRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string corpus_id = 3; */
        if (message.corpusId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.corpusId);
        /* repeated agency.memory.v1.ChunkUpsert chunks = 4; */
        for (let i = 0; i < message.chunks.length; i++)
            ChunkUpsert.internalBinaryWrite(message.chunks[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.StoreRequest
 */
export const StoreRequest = new StoreRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoreResponse$Type extends MessageType<StoreResponse> {
    constructor() {
        super("agency.memory.v1.StoreResponse", [
            { no: 1, name: "document_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 2, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "stored_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "stored_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<StoreResponse>): StoreResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.documentIds = [];
        message.corpusId = "";
        message.storedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<StoreResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StoreResponse): StoreResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string document_ids */ 1:
                    message.documentIds.push(reader.string());
                    break;
                case /* string corpus_id */ 2:
                    message.corpusId = reader.string();
                    break;
                case /* uint32 stored_count */ 3:
                    message.storedCount = reader.uint32();
                    break;
                case /* google.protobuf.Timestamp stored_at */ 4:
                    message.storedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.storedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StoreResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string document_ids = 1; */
        for (let i = 0; i < message.documentIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.documentIds[i]);
        /* string corpus_id = 2; */
        if (message.corpusId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.corpusId);
        /* uint32 stored_count = 3; */
        if (message.storedCount !== 0)
            writer.tag(3, WireType.Varint).uint32(message.storedCount);
        /* google.protobuf.Timestamp stored_at = 4; */
        if (message.storedAt)
            Timestamp.internalBinaryWrite(message.storedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.StoreResponse
 */
export const StoreResponse = new StoreResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QueryRequest$Type extends MessageType<QueryRequest> {
    constructor() {
        super("agency.memory.v1.QueryRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "query_text", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "8192" } } } },
            { no: 4, name: "top_k", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "buf.validate.field": { uint32: { lte: 100, gte: 1 } } } },
            { no: 5, name: "min_relevance_score", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 6, name: "filter_metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 7, name: "corpus_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "256" } } } } } }
        ]);
    }
    create(value?: PartialMessage<QueryRequest>): QueryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.queryText = "";
        message.topK = 0;
        message.minRelevanceScore = 0;
        message.filterMetadata = {};
        message.corpusIds = [];
        if (value !== undefined)
            reflectionMergePartial<QueryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QueryRequest): QueryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string query_text */ 3:
                    message.queryText = reader.string();
                    break;
                case /* uint32 top_k */ 4:
                    message.topK = reader.uint32();
                    break;
                case /* float min_relevance_score */ 5:
                    message.minRelevanceScore = reader.float();
                    break;
                case /* map<string, string> filter_metadata */ 6:
                    this.binaryReadMap6(message.filterMetadata, reader, options);
                    break;
                case /* repeated string corpus_ids */ 7:
                    message.corpusIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: QueryRequest["filterMetadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof QueryRequest["filterMetadata"] | undefined, val: QueryRequest["filterMetadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.memory.v1.QueryRequest.filter_metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: QueryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string query_text = 3; */
        if (message.queryText !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.queryText);
        /* uint32 top_k = 4; */
        if (message.topK !== 0)
            writer.tag(4, WireType.Varint).uint32(message.topK);
        /* float min_relevance_score = 5; */
        if (message.minRelevanceScore !== 0)
            writer.tag(5, WireType.Bit32).float(message.minRelevanceScore);
        /* map<string, string> filter_metadata = 6; */
        for (let k of globalThis.Object.keys(message.filterMetadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.filterMetadata[k]).join();
        /* repeated string corpus_ids = 7; */
        for (let i = 0; i < message.corpusIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.corpusIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.QueryRequest
 */
export const QueryRequest = new QueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QueryResponse$Type extends MessageType<QueryResponse> {
    constructor() {
        super("agency.memory.v1.QueryResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RetrieveResponse, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 2, name: "total_results", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "query_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<QueryResponse>): QueryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.totalResults = 0;
        message.queryTimeMs = 0n;
        if (value !== undefined)
            reflectionMergePartial<QueryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QueryResponse): QueryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.memory.v1.RetrieveResponse results */ 1:
                    message.results.push(RetrieveResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* uint32 total_results */ 2:
                    message.totalResults = reader.uint32();
                    break;
                case /* int64 query_time_ms */ 3:
                    message.queryTimeMs = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: QueryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.memory.v1.RetrieveResponse results = 1; */
        for (let i = 0; i < message.results.length; i++)
            RetrieveResponse.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 total_results = 2; */
        if (message.totalResults !== 0)
            writer.tag(2, WireType.Varint).uint32(message.totalResults);
        /* int64 query_time_ms = 3; */
        if (message.queryTimeMs !== 0n)
            writer.tag(3, WireType.Varint).int64(message.queryTimeMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.QueryResponse
 */
export const QueryResponse = new QueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRequest$Type extends MessageType<UpdateRequest> {
    constructor() {
        super("agency.memory.v1.UpdateRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "chunk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } }
        ]);
    }
    create(value?: PartialMessage<UpdateRequest>): UpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.corpusId = "";
        message.chunkId = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<UpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateRequest): UpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string corpus_id */ 3:
                    message.corpusId = reader.string();
                    break;
                case /* string chunk_id */ 4:
                    message.chunkId = reader.string();
                    break;
                case /* map<string, string> metadata */ 5:
                    this.binaryReadMap5(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: UpdateRequest["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpdateRequest["metadata"] | undefined, val: UpdateRequest["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.memory.v1.UpdateRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: UpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string corpus_id = 3; */
        if (message.corpusId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.corpusId);
        /* string chunk_id = 4; */
        if (message.chunkId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.chunkId);
        /* map<string, string> metadata = 5; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.UpdateRequest
 */
export const UpdateRequest = new UpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateResponse$Type extends MessageType<UpdateResponse> {
    constructor() {
        super("agency.memory.v1.UpdateResponse", [
            { no: 1, name: "chunk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<UpdateResponse>): UpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.chunkId = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateResponse): UpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string chunk_id */ 1:
                    message.chunkId = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 2:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string chunk_id = 1; */
        if (message.chunkId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.chunkId);
        /* google.protobuf.Timestamp updated_at = 2; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.UpdateResponse
 */
export const UpdateResponse = new UpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatsRequest$Type extends MessageType<GetStatsRequest> {
    constructor() {
        super("agency.memory.v1.GetStatsRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<GetStatsRequest>): GetStatsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.corpusId = "";
        if (value !== undefined)
            reflectionMergePartial<GetStatsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatsRequest): GetStatsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string corpus_id */ 3:
                    message.corpusId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string corpus_id = 3; */
        if (message.corpusId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.corpusId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.GetStatsRequest
 */
export const GetStatsRequest = new GetStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatsResponse$Type extends MessageType<GetStatsResponse> {
    constructor() {
        super("agency.memory.v1.GetStatsResponse", [
            { no: 1, name: "total_chunks", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "total_documents", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "storage_bytes", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "corpus_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 5, name: "last_updated", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<GetStatsResponse>): GetStatsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalChunks = 0n;
        message.totalDocuments = 0n;
        message.storageBytes = 0n;
        message.corpusId = "";
        if (value !== undefined)
            reflectionMergePartial<GetStatsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetStatsResponse): GetStatsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 total_chunks */ 1:
                    message.totalChunks = reader.uint64().toBigInt();
                    break;
                case /* uint64 total_documents */ 2:
                    message.totalDocuments = reader.uint64().toBigInt();
                    break;
                case /* uint64 storage_bytes */ 3:
                    message.storageBytes = reader.uint64().toBigInt();
                    break;
                case /* string corpus_id */ 4:
                    message.corpusId = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_updated */ 5:
                    message.lastUpdated = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUpdated);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetStatsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 total_chunks = 1; */
        if (message.totalChunks !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.totalChunks);
        /* uint64 total_documents = 2; */
        if (message.totalDocuments !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.totalDocuments);
        /* uint64 storage_bytes = 3; */
        if (message.storageBytes !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.storageBytes);
        /* string corpus_id = 4; */
        if (message.corpusId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.corpusId);
        /* google.protobuf.Timestamp last_updated = 5; */
        if (message.lastUpdated)
            Timestamp.internalBinaryWrite(message.lastUpdated, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.memory.v1.GetStatsResponse
 */
export const GetStatsResponse = new GetStatsResponse$Type();
/**
 * @generated ServiceType for protobuf service agency.memory.v1.MemoryBackendService
 */
export const MemoryBackendService = new ServiceType("agency.memory.v1.MemoryBackendService", [
    { name: "Retrieve", serverStreaming: true, options: {}, I: RetrieveRequest, O: RetrieveResponse },
    { name: "Upsert", options: {}, I: UpsertRequest, O: UpsertResponse },
    { name: "Search", options: {}, I: SearchRequest, O: SearchResponse },
    { name: "Delete", options: {}, I: DeleteRequest, O: DeleteResponse },
    { name: "Store", options: {}, I: StoreRequest, O: StoreResponse },
    { name: "Query", options: {}, I: QueryRequest, O: QueryResponse },
    { name: "Update", options: {}, I: UpdateRequest, O: UpdateResponse },
    { name: "GetStats", options: {}, I: GetStatsRequest, O: GetStatsResponse }
]);
